import React from 'react';
import {
  FormControl,
  FormLabel,
  InputAdornment,
  TextField,
} from '@mui/material';
import { StyledIcon } from 'src/components/foundations/foundations.styles';
import { BaseInputProps } from './types';

export const DatabaseFieldInput: React.FC<BaseInputProps> = ({
  currentQuestion,
  answers,
  dispatch,
  databaseFieldLabel,
  databaseFieldPlaceholder,
}) => {
  const value = answers[currentQuestion.id]?.databaseFieldSearchText || '';

  return (
    <div data-testid="form-preview-database-field-container">
      <FormControl fullWidth>
        <FormLabel htmlFor={`database-field-${currentQuestion.id}`}>
          {databaseFieldLabel}
        </FormLabel>
        <TextField
          fullWidth
          id={`database-field-${currentQuestion.id}`}
          placeholder={databaseFieldPlaceholder}
          value={value}
          onChange={(e) => {
            dispatch({
              type: 'SET_DATABASE_FIELD_SEARCH',
              questionId: currentQuestion.id,
              payload: e.target.value,
            });
          }}
          slotProps={{
            input: {
              startAdornment: (
                <InputAdornment position="start">
                  <StyledIcon className="uil uil-search" size="20px" />
                </InputAdornment>
              ),
            },
            htmlInput: { 'data-testid': 'form-preview-database-field' },
          }}
        />
      </FormControl>
    </div>
  );
};
